import React from 'react';
import { NavLink } from "react-router-dom";
export default function DataContent({ title, desc, img, imgside , dnone }) {
  return (
    <>


      <section className="gazette-hero">
        <div className="hero-shape shape1"></div>
        <div className="hero-shape shape2"></div>

        <div className="container">
          <div
            className={`row align-items-center ${imgside === "left"
                ? "flex-row-reverse"
                : imgside === "right"
                  ? "flex-row"
                  : ""
              }`}
          >
            <div className='col-lg-12'>
              <div className="hero-contenttitle text-center">
                <span className="hero-badge">India Gazette Services</span>
                <h1 className="hero-contenttitleh1">
                  {title?.split("Name Change")[0]}
                  <span className="highlight-text">Name Change</span>
                  {title?.split("Name Change")[1]}
                </h1>

              </div>
            </div>

              <div
            className={`${dnone === "Yes"
                ? "col-lg-12"
                : dnone === "No"
                  ? "col-lg-7"
                  : ""
              }`}
          >
              <div className="hero-content">
                <div
                  className="contect_desc"
                  dangerouslySetInnerHTML={{
                    __html: desc
                      .replace(/&lt;/g, "<")
                      .replace(/&gt;/g, ">"),
                  }}
                ></div>

                <div className="hero-btns">
                  <NavLink to="" className="btn-main">
                    Whatsapp
                  </NavLink>

                  <NavLink to="" className="btn-outline">
                    Call Now
                  </NavLink>
                </div>

              </div>

            </div>

                  <div
            className={`col-lg-5 ${dnone === "Yes"
                ? "d-none"
                : dnone === "No"
                  ? "d-block"
                  : ""
              }`}
          >
              <div className="hero-image">
                <img src={img} alt="" />

              </div>

            </div>

          </div>


        </div>
      </section>



    </>
  );
}
